import * as React from "react";

import classNames from "classnames";

import DocInlineText from "./InlineText";

import { modifyNodeValueByUIDAndKey } from "../../src/doc_helpers";

interface DocMultipleChoiceProps extends MultipleChoiceNode, EveryNodeArgs {}

export default function DocMultipleChoice(props: DocMultipleChoiceProps) {
  const {
    uid,
    content,
    multipleSelect,
    editState,
    graded,
    inactiveBoolean,
    currentUser,
    feedback,
    currentVersion,
  } = props;

  const onValueChanged: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const state = {[e.target.id]: {value: e.target.checked}};

    if (!multipleSelect) {
      content
        .filter((answerOption) => answerOption.value && answerOption.uid !== e.target.id)
        .forEach((answerOption) => { state[answerOption.uid] = {value: false}; });
    }

    currentUser.addState(state);
  };

  const answers = content.map((answer) => (
    <li key={answer.uid} className={classNames("doc-multiple-choice-answer", {answered: answer.value, [answer.answer ? "correct" : "incorrect"]: graded})}>
      { editState.isEditor && editState.isEditing && (
        <input
          type="checkbox"
          checked={answer.answer}
          onChange={() => { currentVersion._actions.modifyEditJSON((json) => modifyNodeValueByUIDAndKey(json, answer.uid, "answer", () => !answer.answer));}}
        />
      )}
      <input
        type="checkbox"
        id={answer.uid}
        className="value-checkbox"
        disabled={inactiveBoolean}
        checked={answer.value}
        onChange={onValueChanged}
      />
      <label
        htmlFor={answer.uid}
      >
        <span className="doc-multiple-choice-answer-outer"><span className="doc-multiple-choice-answer-inner" /></span>
        <span className="doc-multiple-choice-answer-title">
          <DocInlineText content={answer.content} uid={answer.uid} contentKey="content" editState={editState} />
        </span>
        {graded && (answer.value || answer.answer) && (
          <span style={{marginLeft: "10px"}}>
            {answer.answer ? <i className="fa fa-check text-green-600" /> : <i className="fa fa-xmark text-red-700" /> }
          </span>
        )}
      </label>
    </li>
  ));

  let renderedFeedback;
  if (graded || (editState.isEditor && editState.isEditing)) {
    const feedbackAnswers = content.map((answer) => (
      <li key={answer.uid} className="doc-multiple-choice-answer">
        <DocInlineText content={answer.content} uid={answer.uid} contentKey="content" editState={editState} />
        <span style={{marginLeft: "10px"}}>
          {answer.answer ? <i className="fa fa-check text-green-600" /> : <i className="fa fa-xmark text-red-700" /> }
          {answer.feedback}
        </span>
      </li>
    ));

    let renderedExtraFeedback;
    if (editState.isEditor && editState.isEditing) {
      renderedExtraFeedback = (
        <textarea
          value={feedback}
          onChange={(e) => currentVersion._actions.modifyEditJSON((json) => modifyNodeValueByUIDAndKey(json, uid, "feedback", () => e.target.value))}
          onClick={() => editState.setCurrentlyEditing(undefined)}
        />
      );
    } else if(feedback) {
      renderedExtraFeedback = feedback.split(/\r?\n/).map((splitFeedback, i) => (
        <p key={i}>
          {splitFeedback}
        </p>
      ));
    }

    renderedFeedback = (
      <div className="border-solid border-2 border-black p-3 mt-3">
        <h4>Correct Answers:</h4>
        {feedbackAnswers}
        <hr />
        {renderedExtraFeedback}
      </div>
    );
  }

  const instructions = multipleSelect ?
    <i>Select all that apply</i> :
    <i>Select the best answer</i>;

  return (
    <ul className={classNames("doc-multiple-choice", {inactive: inactiveBoolean, graded})}>
      {instructions}
      {answers}
      {renderedFeedback}
    </ul>
  );
}
